import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { openModal } from '../../actions/ModalActions';
import discountApi from '../../components/discounts/discountApi';
import PromotionFormModal from '../../components/discounts/PromotionFormModal';
import { shortDate, couponTerms, labelClass } from '../../utils/discountFormat';

/** OPE-112: every promotion code across all coupons, with status / country filters. Coupons are the landing page; this is the flat view. */
@connect(
    state => ({ canManage: state.auth.user.permissions.includes('MANAGE_DISCOUNTS') }),
    dispatch => bindActionCreators({ openModal }, dispatch)
)
export default class Promotions extends Component {
    constructor(props) {
        super(props);
        this.state = { promotions: null, reference: null, status: '', country: '', error: null };
    }

    componentDidMount() {
        document.title = 'Discounts | Fergus CRM';
        discountApi.referenceData().then(reference => this.setState({ reference })).catch(error => this.setState({ error: error.message }));
        this.load();
    }

    componentWillUnmount() {
        document.title = 'Fergus CRM';
    }

    load(filters = {}) {
        var status = filters.status !== undefined ? filters.status : this.state.status;
        var country = filters.country !== undefined ? filters.country : this.state.country;
        var query = {};
        if (status) { query.status = status; }
        if (country) { query.country = country; }
        this.setState({ promotions: null, error: null, status, country });
        discountApi.listPromotions(query)
            .then(promotions => this.setState({ promotions }))
            .catch(error => this.setState({ error: error.message, promotions: [] }));
    }

    countries() {
        return this.state.reference ? (this.state.reference.countries || []) : [];
    }

    openCreate() {
        this.props.openModal(PromotionFormModal, { reference: this.state.reference, onDone: () => this.load() });
    }

    render() {
        var { promotions, reference, status, country, error } = this.state;
        return (
            <div className="row page-todo">
                <ol className="breadcrumb page-breadcrumb">
                    <li><Link to="/discounts">Coupons</Link></li>
                    <li className="active">Promotion codes</li>
                </ol>
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-heading" style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ flex: 1, margin: 0 }}><i className="fa fa-tag"></i> Promotion codes <small className="text-muted">across every coupon</small></h2>
                            <select className="form-control input-sm" style={{ width: 140, marginRight: 8 }} value={status} onChange={e => this.load({ status: e.target.value })}>
                                <option value="">All statuses</option>
                                {reference && reference.enums.promotion_statuses.map(s => <option key={s} value={s}>{s}</option>)}
                            </select>
                            <select className="form-control input-sm" style={{ width: 140, marginRight: 8 }} value={country} onChange={e => this.load({ country: e.target.value })}>
                                <option value="">All countries</option>
                                {this.countries().map(c => <option key={c.code} value={c.code}>{c.name}</option>)}
                            </select>
                            {this.props.canManage && reference &&
                                <button type="button" className="btn btn-sm btn-info" onClick={this.openCreate.bind(this)}><i className="fa fa-plus-square"></i> Add promotion code</button>
                            }
                        </div>
                        <div className="panel-body no-padding">
                            {error && <div className="alert alert-danger" style={{ margin: 10 }}>{error}</div>}
                            {promotions === null && !error && <p className="text-muted" style={{ padding: 10 }}>Loading...</p>}
                            {promotions && promotions.length === 0 && <p className="text-muted" style={{ padding: 10 }}>No promotions match.</p>}
                            {promotions && promotions.length > 0 &&
                                <table className="table table-hover" style={{ marginBottom: 0 }}>
                                    <thead>
                                        <tr><th>Promotion code</th><th>Name</th><th>Status</th><th>Coupon</th><th>Scheme</th><th>Countries</th><th>Eligibility</th><th>Auto-apply</th><th>Expires</th><th>Created</th></tr>
                                    </thead>
                                    <tbody>
                                        {promotions.map(p =>
                                            <tr key={p.promotion_id} className={p.status === 'archived' ? 'text-muted' : ''}>
                                                <td>{p.code ? <code>{p.code}</code> : <span className="text-muted">no code</span>}</td>
                                                <td><Link to={`/discounts/promotions/${p.promotion_id}`}>{p.name}</Link><div className="text-muted"><small>{p.slug}</small></div></td>
                                                <td><span className={labelClass(p.status)}>{p.status}</span></td>
                                                <td>{p.coupon ? <Link to={`/discounts/coupons/${p.coupon.coupon_id}`}>{p.coupon.invoice_name}</Link> : <span className="text-muted">none yet</span>}{p.coupon && <div className="text-muted"><small>{couponTerms(p.coupon)}</small></div>}</td>
                                                <td>{p.scheme_type}</td>
                                                <td>{(p.countries || []).join(', ') || '–'}</td>
                                                <td>{p.customer_eligibility}</td>
                                                <td>{p.auto_apply ? 'yes' : 'no'}</td>
                                                <td>{p.redemption_ends_at ? shortDate(p.redemption_ends_at) : <span className="text-muted">—</span>}</td>
                                                <td>{shortDate(p.created_at)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/discounts/Promotions.js